var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    rx: 16,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.329 116.667H116.662C112.067 116.667 108.329 120.404 108.329 125V175C108.329 179.596 112.067 183.333 116.662 183.333H183.329C187.925 183.333 191.662 179.596 191.662 175V125C191.662 120.404 187.925 116.667 183.329 116.667ZM127.079 129.167C128.737 129.167 130.326 129.825 131.499 130.997C132.671 132.169 133.329 133.759 133.329 135.417C133.329 137.074 132.671 138.664 131.499 139.836C130.326 141.008 128.737 141.667 127.079 141.667C125.422 141.667 123.832 141.008 122.66 139.836C121.488 138.664 120.829 137.074 120.829 135.417C120.829 133.759 121.488 132.169 122.66 130.997C123.832 129.825 125.422 129.167 127.079 129.167V129.167ZM149.996 170.833H120.829L137.496 150L143.746 158.333L156.246 141.667L179.162 170.833H149.996Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUpload);
export default __webpack_public_path__ + "static/media/default-upload.46bff3db9f285bdc63efddb69fc346bd.svg";
export { ForwardRef as ReactComponent };